<template>

    <v-loader v-if="starting" size="lg" centered />

    <div v-else>

        <v-page-filters floating>
            <v-searchbar :model="query" @input="query = $event" />
            <v-traits-selector label="Visibility" type="profile" :is-draggable="false" menu-right />
        </v-page-filters>

        <v-notice v-if="!groups.length" title="No Traits" message="No traits found for this customer." />

        <div v-else>
            <v-page-section v-for="group in groups" :key="group.key" padded>
                <template #title>{{ group.name }}</template>
                <template #body>
                    <v-trait-item v-for="trait in group.traits"
                        :key="trait.field"
                        :trait="trait"
                        :customer="customer"
                        :disabled="trait.editable ? false : true">
                    </v-trait-item>
                </template>
            </v-page-section>
        </div>

    </div>

</template>

<script>

import { titleCase } from 'title-case';
import CustomerApi from '@api/CustomerApi';
import TraitItem from './components/TraitItem';

export default {

    components: {
        'v-trait-item': TraitItem,
    },

    data() {
        return {
            starting: true,
            customer: null,
            query: '',
        }
    },

    computed: {

        groups() {
            // Make unique groups.
            let groups = [];
            this.$store.getters.project.traits.forEach(trait => {
                let parts = trait.field.split('.');
                let key = parts.length > 1 ? parts[0] : 'attributes';
                let prefix = parts.length > 1 ? parts[0] : null;
                groups[key] = {
                    'key': key,
                    'name': titleCase(key.split('_').join(' ')),
                    'prefix': prefix,
                    'sort': this.sortForGroup(prefix),
                }
            });
            // Add traits to group.
            Object.values(groups).forEach(group => {
                groups[group.key]['traits'] = this.traitsForGroup(group.prefix);
            });
            // Return sorted array.
            return Object.values(groups).filter(group => {
                return group.traits.length > 0;
            }).sort((a, b) => {
                return a.name.localeCompare(b.name);
            }).sort((a, b) => a.sort - b.sort);
        },

    },

    mounted() {
        this.getCustomer();
    },

    methods: {

        getCustomer() {
            this.$store.commit('loading', true);
            CustomerApi.getCustomer(this.$route.params.id)
                .then((response) => {
                    this.starting = false;
                    this.$store.commit('loading', false);
                    this.customer = response.data.data;
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        traitsForGroup(prefix) {
            return this.$store.getters.project.traits.filter(trait => {
                if (!trait.visibility.profile) return false;
                if (prefix && trait.field.startsWith(`${prefix}.`)) {
                    // Namespaced attribute.
                    if (!this.query || trait.name.toLowerCase().includes(this.query.toLowerCase())) {
                        return true;
                    }
                } else if (!prefix && trait.field.split('.').length === 1) {
                    // Standard attribute.
                    if (!this.query || trait.name.toLowerCase().includes(this.query.toLowerCase())) {
                        return true;
                    }
                }
            });
        },

        sortForGroup(prefix) {
            if (!prefix) return 1;
            if (prefix === 'custom_attributes') return 2;
            return 100;
        },

    }

}

</script>
